
import Header from "@/components/header/header.vue";
import Comment from "@/components/comment/index.vue";
import { inject, reactive, shallowRef,ref, Ref } from "vue";
import { useRoute } from "vue-router";
import { getCommentList } from "@/hooks/index";
import router from "@/router";

export default {
  components: {
    Header,
    Comment,
  },
  setup() {
    const $http: any = inject("$http");
    const route: any = useRoute();
    let commentList = shallowRef([]);
    const loading = ref(false);
    const finished = ref(false);
    let active = ref(1);
    let tabList:any = shallowRef([
      {
        title:'All',
        id:'1'
      }, 
        {
        title:'5star',
        id:'15'
      },
        {
        title:'4star',
        id:'14'
      },
        {
        title:'3star',
        id:'13'
      },
        {
        title:'2star',
        id:'12'
      },
      {
        title:'1star',
        id:'11'
      },
    ])
    const back_fn = () => {
      window.history.back()
    }
    interface commentParams {
      pageNo: number,
      pageSize: number,
      objectId: string,
      queryType: number | String,
      objectType: number
    }
    let comment_params: Ref<commentParams> = ref({
      queryType: 1,
      objectType: 1,
      objectId: route.query.goodsId,
      pageSize: 10,
      pageNo: 1
    })
    let onLoad = async ()=>{     
      let req = await getCommentList($http, comment_params.value)  
      if (req.code == 200 && req.data  &&  req.data.length > 0) {      
        commentList.value = commentList.value.concat(req.data)           
        comment_params.value.pageNo += 1
        loading.value = false
      }else{   
          finished.value = true
      }    
    }
    let onTabs =  (name:String,title:String)=>{
      comment_params.value.queryType = name
      comment_params.value.pageNo = 1
      commentList.value = []
        loading.value = true
      onLoad()
    }
    
    return {
      commentList,
       loading,
        finished,
        onLoad,
        tabList,
        onTabs,
        active,
        back_fn
    };
  },
};
